import { toast } from "react-toastify";


const API_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";
export const refreshAccessToken = async (): Promise<string | null> => {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) return null;

  const urldata = `${API_URL}/api/refresh-token`;

  try {
    const responses = await fetch(urldata, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ refresh_token: refreshToken }),
    });


    if (!responses.ok) throw new Error("Échec du refresh token");

    const data = await responses.json();

    localStorage.setItem("token", data.token);

    return data.token;
  } catch (error) {
    toast.error("Erreur lors du rafraîchissement du token. Veuillez vous reconnecter.");
    return null;
  }
};

